<template>
  <div class="columns">
    <div class="column is-half is-offset-one-quarter">
      <div class="notification is-primary content">
        {{ message }} <span class="icon is-pulled-right"><i class="fas fa-sync fa-spin"></i></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: 'De data wordt geladen'
    }
  }
}
</script>

<style scoped>
  .notification {
    top: 50%;
  }
</style>
